/**
 * @description: 商品配送
 * @author: hwx
 * @update: lyr
 */
<template>
	<div>
		<div class="commodity-distribt" v-show="showList">
			<div class="row row-margin" v-if="list_menu_add">
				<button type="button" class="btn bg-orange btn-flat bigbtn" @click="addDistribt">新增配送规则</button>
			</div>
			<div class="row row-margin">
				<label class="ct-label">时间:</label>
				<div class="col-md-3" style="width: 335px">
					<div id="time-wrapper" @click="clearDate" ref="time">
						<input type="text" class="form-control laydate-icon" :value="startTime" style="display:inline-block; width: 145px;"> -
						<input type="text" class="form-control laydate-icon" :value="endTime" style="display:inline-block; width: 145px;">
					</div>
				</div>
				<label class="ct-label">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="shop" data-placeholder="请选择门店"></select>
				</div>
				<label class="ct-label">包厢号:</label>
				<div class="col-lg-2">
					<div class="input-group">
						<input type="text" class="form-control" placeholder="请选择包厢号" ref="room_num">
						<div class="input-group-btn">
							<ul class="dropdown-menu dropdown-menu-right" role="menu"></ul>
						</div>
					</div>
				</div>
				<label class="ct-label">配送方式:</label>
				<div class="col-lg-2 ct-col">
					<select class="select2 ct-select" ref="distribt_type" data-placeholder="请选择配送方式">
						<option value=" ">全部</option>
						<option value="1">固定配送</option>
						<option value="2">手工配送</option>
					</select>
				</div>
			</div>
			<div class="row">
				<label class="ct-label">状态:</label>
				<div class="col-lg-2 ct-col">
					<select class="select2 ct-select" ref="distribt_status" data-placeholder="请选择状态">
						<option value=" ">全部</option>
						<option value="1">启用</option>
						<option value="-1">禁用</option>
					</select>
				</div>
				<label class="ct-label">规则名称:</label>
				<div class="col-md-2">
					<input class="form-control" placeholder="请输入规则名称" v-model="list_rule_name">
				</div>
				<label class="ct-label">适用商品:</label>
				<div class="col-md-2">
					<input class="form-control" placeholder="请输入适用商品名称" v-model="list_right_name">
				</div>
				<label class="ct-label">配送商品:</label>
				<div class="col-md-2">
					<input class="form-control" placeholder="请输入配送商品名称" v-model="list_distr_name">
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="clkQuery">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="distribt_list"></table>
			</div>
		</div>
		<!-- 添加、修改 -->
		<div class="distribt-edit" v-show="showEdit">
			<div class="page-tit">{{add_header}}</div>
			<div class="row">
				<label class="ctr-label-left">门店:</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="add_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">优先级:</label>
				<div class="col-md-6">
					<input class="form-control" v-model="add_priority" ref="add_priority" placeholder="请输入规则优先级：例如01、02、03">
				</div>
				<span class="rmarkspan" titles="数值大的优先" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">规则名称:</label>
				<div class="col-md-6">
					<input class="form-control" v-model="add_rule" ref="add_rule" placeholder='请输入规则名称，例如：买"轩尼诗1瓶"送"果盘2份，花生米3包，矿泉水1瓶"'>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">适用商品:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择适用商品/商品套餐" v-model="right_goods" ref="right_goods" readonly="readonly" @click="right_goods_fun($event)">
					<span :class="objClass" @click="clear_input('right_goods')">×</span>
					<span class="printer_arrow" role="presentation">
						<b role="presentation"></b>
					</span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">配送起购数:</label>
				<div class="col-md-6 flex-row">
					<input class="form-control" v-model="distribt_min" ref="distribt_min" placeholder="请输入配送起购数量。购买适用商品数量达到配送起购数时才配送商品。">
					<el-checkbox v-model="accumulate" :disabled="addModify=='3'">累计配送</el-checkbox>
				</div>
				<span class="rmarkspan" titles="说明：勾选累计配送，则分次购买适用商品合计数量达到配送起够数时，也可配送商品。默认不勾选，则需一次性购买适用商品数量达到起够数，才可配送商品！" @mouseenter="hint_language($event)" @mouseleave="close_hint_language"></span>
			</div>
			<div class="row">
				<label class="ctr-label-left">配送方式:</label>
				<div class="col-md-6">
					<input type="text" class="ChooseType form-control input-readonly" placeholder="请选择配送方式" ref="add_distribt_type" v-model="distribt_type_name" readonly @click="addTypeSel">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">配送商品:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择配送的商品" v-model="distribt_gooods" ref="distribt_gooods" readonly="readonly" @click="distribt_gooods_fun($event)">
					<span :class="objClass" @click="clear_input('distribt_gooods')">×</span>
					<span class="printer_arrow" role="presentation">
						<b role="presentation"></b>
					</span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">适用包厢：</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择包厢号" v-model="distribt_box_txt" ref="distribt_box_txt" readonly="readonly" @click="go_distribt_box($event)">
					<span :class="objClass" @click="clear_box_txt()">×</span>
					<span class="printer_arrow" role="presentation"><b role="presentation"></b></span>
				</div>
			</div>
			<div class="row distribt-usedate-wrap">
				<label class="ctr-label-left">使用日期:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" v-model="add_play_date" placeholder="请选择使用日期" ref="add_play_date" readonly="readonly">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">使用时间:</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" v-model="add_play_time" ref="add_play_time" placeholder="请选择使用时间" readonly="readonly" @click="timePop()">
					<span class="selection_clear" @click="clear_input('add_play_time')">×</span>
					<span class="printer_arrow" role="presentation">
						<b role="presentation"></b>
					</span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">有效星期日</label>
				<div class="col-md-6">
					<input type="text" class="form-control input-readonly" placeholder="请输入有效星期日" v-model="week" ref="week" readonly="readonly" @click="weekPop($event)">
					<span class="selection-clear" @click="clear_input('week')">×</span>
					<span class="span-arrow" role="presentation"><b></b></span>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-middle btn-flat btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-middle bg-orange btn-flat sub-margin" @click="addSub(addModify)">确定</button>
			</div>

			<!--选择配送方式弹窗-->
			<div class="type_popup">
				<ul class="chooseType-content type-choose" ref="chooseType-content">
					<li class="clearfix">
						<input type="radio" name="a" id="" value="固定配送" data-id="1" />
						<div class="choosetype-txt">
							<p>固定配送</p>
							<p class="orange-text turnRed">（销售时配送商品的商品和数量不能选择）</p>
						</div>
					</li>
					<li class="clearfix">
						<input type="radio" name="a" id="" value="手工配送" data-id="2" />
						<div class="choosetype-txt">
							<p>手工配送</p>
							<p class="orange-text turnRed">（销售时配送商品的商品和数量可以选择）</p>
						</div>
					</li>
				</ul>
				<div class="chooseType-btn">
					<button type="button" class="btn btn-middle btn-flat btn-border-gray" style="margin-left: 0;" @click="closelayer">取消</button>
					<button type="button" class="btn btn-middle bg-orange btn-flat" style="margin-left:50px" @click="sureChooseType">确定</button>
				</div>
			</div>
			<!--时间选择弹窗-->
			<div class="distb-time-popup">
				<div class="chooseTime_popup-wrap">
					<div class="chooseTime_popup_title">
						开始时间：
						<div>
							<input type="checkbox" v-model="dist_time" value="1">
							<label>全天</label>
						</div>
					</div>
					<select ref="starthour"></select>
					<label class="colon">:</label>
					<select ref="startseconds"></select>
					<div class="chooseTime_popup_title">结束时间：</div>
					<select ref="stophour" id="stophour"></select>
					<label class="colon">:</label>
					<select ref="stopseconds"></select>
				</div>
			</div>
			<!-- 星期选择弹窗 -->
			<div class="ele-hide" ref="week_popup">
				<div class="multi-select">
					<div class="clearfix">
						<li>
							<input type='checkbox' v-model='week_allcheck' @click='weekCheckedAll'>
							<label>全选</label>
						</li>
					</div>
					<ul class="clearfix">
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="1">
							<label>星期一</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="2">
							<label>星期二</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="3">
							<label>星期三</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="4">
							<label>星期四</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="5">
							<label>星期五</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="6">
							<label>星期六</label>
						</li>
						<li>
							<input type="checkbox" v-model='week_checkboxModel' value="0">
							<label>星期日</label>
						</li>
					</ul>
				</div>
			</div>

		</div>
		<!-- 适用商品页 -->
		<div class="page-right-goods" v-show="showRight">
			<div class="row">
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="submitRight">确定</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addRightGoods">添加商品/商品套餐</button>
				</div>
			</div>
			<div class="row page-right-goods-txt">
				<h3>适用商品/商品套餐</h3>
				<p>当前还没添加任何商品/商品套餐，请点击【添加商品/商品套餐】</p>
			</div>
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="right_goods_table"></table>
			</div>
		</div>
		<!-- 添加商品弹窗 -->
		<div class="add-goods" ref="addgoods">
			<div class="col-md-12">
				<div class="col-md-4 ct-col">
					<select class="form-control" id="good-type" data-placeholder="商品类型" ref="goodtype">
						<option value=""></option>
					</select>
				</div>
				<div class="col-md-6" style="padding-right: 0;">
					<input type="text" class="form-control" id="good-name" placeholder="请输入商品名称" ref="goodname" @keyup.13="queryGoods" />
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-small btn-orange" id="pop-querry" @click="queryGoods">查询</button>
				</div>
			</div>
			<div class="table-responsive" style="margin-top: 20px;">
				<table id="goods-list" class="table table-bordered table-hover" data-pagination="true" ref="goodslist" style="margin-top:20px"></table>
			</div>
			<div class="row btns">
				<button type="button" class="btn btn-flat btn-small btn-orange" id="pop-save" @click="saveGoods" style="margin: 0 50px 0 180px;">保存</button>
				<button type="button" class="btn btn-flat btn-small btn-gray" id="pop-cancel" @click="closelayer">取消</button>
			</div>
		</div>

		<!-- 配送商品页 -->
		<div class="page-distb" v-show="showDistb">
			<div class="row">
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backToEdit">返回</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="submitDistb">确定</button>
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addDistbGoods">添加商品</button>
				</div>
			</div>
			<div class="row page-distb-txt">
				<h3>配送商品</h3>
				<div class="row">
					<label class="col-md-1 ctr-label-left">配送总数:</label>
					<div class="col-md-3">
						<input class="form-control" v-model="distb_all" ref="distb_all" placeholder="请输入配送总数">
					</div>
				</div>
				<div class="row">
					<p class="p-hint col-md-8">默认数量：1、设置默认数量后，点单时如果未挑选配送商品，则系统自动出品已设置的默认数量商品<br />2、当默认数量均设置为0时，下单时系统弹窗要求选择配送商品数量</p>
					<div class="pull-right col-md-4">
						<div class="col-md-8">
							<input class="form-control" placeholder="请输入已添加配送商品名称" v-model="alreadyAddName">
						</div>
						<div class="col-md-2">
							<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryAlreadyAddGoods">查询</button>
						</div>
					</div>
				</div>
				
			</div>
			<div class="table-responsive" v-show="!showFilterAlreadyAddGoods">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="distb_table"></table>
			</div>
			<div class="table-responsive" v-show="showFilterAlreadyAddGoods">
				<table class="table table-striped table-bordered table-hover" data-pagination="true" ref="filter_table"></table>
			</div>
		</div>
		<!-- 添加配送商品弹窗 -->
		<div class="add-disbt-goods" ref="addDistbGoods">
			<div class="col-md-12">
				<div class="col-md-4 ct-col">
					<select class="form-control" data-placeholder="商品类型" ref="distbGoodtype">
						<option value=""></option>
					</select>
				</div>
				<div class="col-md-6" style="padding-right: 0;">
					<input type="text" class="form-control" placeholder="请输入商品名称" ref="distbGoodname" @keyup.13="distbQueryGoods" />
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="distbQueryGoods">查询</button>
				</div>
			</div>
			<div class="table-responsive" style="margin-top: 20px;">
				<table class="table table-bordered table-hover" data-pagination="true" ref="distbGoodslist" style="margin-top:20px"></table>
			</div>
			<div class="row btns">
				<button type="button" class="btn btn-flat btn-small btn-orange" id="pop-save" @click="saveDistbGoods" style="margin: 0 50px 0 180px;">保存</button>
				<button type="button" class="btn btn-flat btn-small btn-gray" id="pop-cancel" @click="closelayer">取消</button>
			</div>
		</div>

		<!-- 包厢号 -->
        <div class="details_content distb-room-page" ref="box_area" v-show="showbox">
            <div class="page-tit">选择包厢</div>
            <ul class="distb-room-type clearfix">
            	<li class="distb-room-sel" @click="roomTypeCg(1)">按包厢区域显示</li>
            	<li @click="roomTypeCg(2)">按包厢类型显示</li>
            </ul>
            <p>请选择包厢范围</p>
            <div class="box_area_main">
                <div class="goods_checkboxdiv box_area">
                    <div class="first">
                        <input type="checkbox" v-model='box_allcheck' @click='roomAllcheck'>
                        <span>全部包厢</span>
                    </div>
                    <ul></ul>
                </div>
                <div class="goods_checkboxdiv box_area" v-for="(items, index) in room_checkboxdata" :key="items.room_area">
                    <div class="first">
                        <input type="checkbox" v-model='room_flrModel' :value="items.room_area" @click="roomFlr(items.room_area, index)">
                        <span>{{items.room_area_name}}</span>
                    </div>
                    <ul>
                        <li v-for="item in items.room" :key="item.id">
                            <input type="checkbox" v-model='room_checkboxModel' :value="item.id">
                            <span>{{item.name}}</span>
                        </li>
                        <div style="clear:both;"></div>
                    </ul>
                </div>
            </div>
            <div class="row" style="padding-top: 30px;">
                <button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="roomboxbackFun()">返回</button>
                <button type="button" class="btn btn-flat btn-middle btn-orange" style="margin-left: 40px;" @click="roomboxokFun()">确定</button>
            </div>
        </div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		data() {
			return {
				showList: true,
				showEdit: false,
				showDetail: false,
				showRight: false,
				showDistb: false,
				showbox: false,

				list_menu_add: false,
            	list_menu_op: [],
                addModify: 1,
				startTime: "",
				endTime: "",
				roomNumData: {},
				list_rule_name: '',
				list_right_name: '',
				list_distr_name: '',
				add_header: '新增配送规则',
				add_shop_data: [],
				add_priority: '',
				add_rule: '',
				right_goods: [],
				objClass: {
					visi_hid: true,
					selection_clear: true
				},
				distribt_min: '',
				accumulate: false, // 累计配送
				distribt_type_id: '',
				distribt_type_name: '',
				distribt_gooods: [],
				add_play_date: '',
				// add_play_time: '',
				dist_time: '',
				time_start_time: '',
				time_end_time: '',
				goodsType_list: [],
				detail_list: [],
				operateType: 'add',

				distb_goodstype: [],
				distb_detail_list: [],
				distb_all: '',

				add_play_dateModel: "",

				remenberNum: {
					day: "",
					day_str: "",
					boxType: ""
				},
				theDetail: {},

				total_actual_pay: '',
				goods_type_sign: '',
				goods_type_sign_id: '',

				distribt_box_txt: '',
				box_allcheck: false,
				c_box_allcheck: false,
				room_flrModel: [],
				c_room_flrModel: [],
				room_checkboxdata: [],
				room_checkboxModel: [],
				room_detailcheckboxdata: [],
				room_type: 1,
				c_room_all: [],
				c_room_checkboxModel: [],
				c_room_type: 1,
				use_all_room: '',
				use_all_day: '',

				week: '',
				week_allcheck: false,
				c_week_allcheck: false,
				week_checkboxModel: [],
				week_checkboxData: [{id: "1", name: "一"}, {id: "2", name: "二"}, {id: "3", name: "三"}, {id: "4", name: "四"}, {id: "5", name: "五"}, {id: "6", name: "六"}, {id: "0", name: "日"}],

				alreadyAddName: '', // 已添加配送商品名称检索
				filterAlreadyAddGoods: [], // 已添加配送商品检索结果
				showFilterAlreadyAddGoods: false, // 显示检索结果
			}
		},
		computed: {
			add_play_time() {
				let _this = this;
				if(this.dist_time == '1') {
					this.use_all_day = '1';
					return '全天';
				} else {
					if(_this.time_start_time == '00:00' && _this.time_end_time == '00:00') {
						this.use_all_day = '1';
						return '全天';
					} else {
						this.use_all_day = '-1';
						return _this.time_start_time + "-" + _this.time_end_time;
					}
				}
			},
		},
		watch: {
			room_checkboxModel: {
				handler: function(val, oldVal) {
					let _this = this;

					if(this.room_checkboxModel.length >= this.room_detailcheckboxdata.length) {
						this.box_allcheck = true;
						this.c_box_allcheck = this.box_allcheck;
					} else {
						this.box_allcheck = false;
						this.c_box_allcheck = this.box_allcheck;
					}

					$.each(_this.room_checkboxdata, function(k, v) {
						if(_this.room_checkboxModel.length >= v.room.length) {
							let num = 0;
							for(let i = 0, len = v.room.length; i < len; i++) {
								if(_this.room_checkboxModel.indexOf(v.room[i].id) != -1) {
									num++;
								}
								if(i == v.room.length - 1 && num == v.room.length) {
									if(_this.room_flrModel.indexOf(v.room_area) == -1) {
										_this.room_flrModel.push(v.room_area);
									}
								} else {
									let index = '';
									index = _this.room_flrModel.indexOf(v.room_area);
									if(index != -1) {
										_this.room_flrModel.splice(index, 1);
									}
								}
							}
						} else {
							let index = '';
							index = _this.room_flrModel.indexOf(v.room_area);
							if(index != -1) {
								_this.room_flrModel.splice(index, 1);
							}
						}
					});
					_this.c_room_flrModel = _this.room_flrModel;

				},
				deep: true
			},

			week: {
				handler: function(val, oldval) {
					if(val != ""){
						$(this.$refs.week).parent().find('.selection-clear').show();
					} else {
						$(this.$refs.week).parent().find('.selection-clear').hide();
					}
				},
				deep: true
			},
			week_checkboxModel: {
				handler: function (val, oldVal) {
					if(this.week_checkboxModel.length >= this.week_checkboxData.length) {
						this.week_allcheck = true;
						this.c_week_allcheck = true;
					} else {
						this.week_allcheck = false;
						this.c_week_allcheck = false;
					}
				},
				deep: true
			},
			dist_time: {
				handler: function (val, oldVal) {
					if(this.dist_time == '1') {
						$(this.$refs.starthour).attr('disabled', true);
						$(this.$refs.startseconds).attr('disabled', true);
						$(this.$refs.stophour).attr('disabled', true);
						$(this.$refs.stopseconds).attr('disabled', true);
					} else {
						$(this.$refs.starthour).attr('disabled', false);
						$(this.$refs.startseconds).attr('disabled', false);
						$(this.$refs.stophour).attr('disabled', false);
						$(this.$refs.stopseconds).attr('disabled', false);
					}
				},
				deep: true
			},
			alreadyAddName: {
				handler: function(val, oldval) {
					if(val == ""){
						this.showFilterAlreadyAddGoods = false
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.getMenuOp();
			this.$nextTick(function() {
				var _this = this;
				// 日期
				var myDate = new Date();
				this.IntstartTime = myDate;
				this.IntendTime = new Date(myDate.getTime() + 1 * 24 * 3600 * 1000);
				this.IntstartTime.setHours(8, 0);
				this.IntendTime.setHours(8, 0);
				var timStar = new Date(this.IntstartTime),
					year = timStar.getFullYear(),
					month = (timStar.getMonth() + 1) < 10 ? '0' + (timStar.getMonth() + 1) : (timStar.getMonth()     + 1),
					day = timStar.getDate() < 10 ? '0' + timStar.getDate() : timStar.getDate(),
					hour = timStar.getHours() < 10 ? '0' + timStar.getHours() : timStar.getHours(),
					minute = timStar.getMinutes() < 10 ? '0' + timStar.getMinutes() : timStar.getMinutes();
				var timEnd = new Date(this.IntendTime),
					yearend = timEnd.getFullYear(),
					monthend = (timEnd.getMonth() + 1) < 10 ? '0' + (timEnd.getMonth() + 1) : (timEnd.getMonth() + 1),
					dayend = timEnd.getDate() < 10 ? '0' + timEnd.getDate() : timEnd.getDate(),
					hourend = timEnd.getHours() < 10 ? '0' + timEnd.getHours() : timEnd.getHours(),
					minuteend = timEnd.getMinutes() < 10 ? '0' + timEnd.getMinutes() : timEnd.getMinutes();
				this.startTime = year + '-' + month + '-' + day + ' ' + hour + ':' + minute;
				this.endTime = yearend + '-' + monthend + '-' + dayend + ' ' + hourend + ':' + minuteend;
				this.innitDate();

				this.getShopData();
				$(this.$refs.distribt_type).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(this.$refs.distribt_status).select2({
					language: "zh-CN",
					allowClear: true,
					minimumResultsForSearch: -1,
					width: '100%'
				});
				$(this.$refs.distribt_status).val(1).trigger('change');
				this.selectTime();
			});
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '583') {
									menu = n.submenu;
								}
							});
						}
					});

					_this.list_menu_op = [{cls: 'text-blue status', name: '状态'}, {cls: 'text-blue detail', name: '详情'}];
					$.each(menu, function(x, y) {
						if(y.id == '927') {
							_this.list_menu_add = true;
							_this.list_menu_op.push({cls: 'text-blue copyAdd', name: '复制新增'});
						}
						if(y.id == '928') {
							_this.list_menu_op.push({cls: 'text-blue edit', name: '修改'});
						}
						if(y.id == '929') {
							_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
						}
					});
				}
			},
			//清空日期
			clearDate: function() {
				this.startTime = "";
				this.endTime = "";
			},
			// 初始化日期插件
			innitDate: function() {
				let _this = this;
				$(_this.$refs.time).daterangepicker({
					timePicker: true,
					timePickerIncrement: 1,
					timePicker12Hour: false,
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
					startDate: _this.IntstartTime,
					endDate: _this.IntendTime
				}, function(start, end, label) {
					_this.startTime = start.format('YYYY-MM-DD HH:mm');
					_this.endTime = end.format('YYYY-MM-DD HH:mm');
				});
				// 取消按钮
				$(_this.$refs.time).on('cancel.daterangepicker', function(ev, picker) {
					_this.startTime = "";
					_this.endTime = "";
				});
			},
			// 获取门店数据
			getShopData: function() {
				let _this = this;

				let shopDatas = [];
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result, function(k, v) {
								shopDatas.push({ id: v.id, text: v.name });
							});
							shopDatas.shift();
							$(_this.$refs.shop).select2({
								data: shopDatas,
								allowClear: true,
								minimumResultsForSearch: -1,
								language: "zh-CN"
							}).on("select2:select", function(e) {
								$(_this.$refs.room_num).val("").trigger('change');
								_this.getRoomNumData(e.params.data.id);
							});
							$(_this.$refs.shop).val("").trigger('change');
							_this.getRoomNumData($(_this.$refs.shop).val());
							_this.innitTable();

							_this.add_shop_data = shopDatas;
							_this.addShopData();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 包厢号数据
			getRoomNumData: function(shop_id) {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": shop_id || ""
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getAllRoom",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.roomNumData = data.response.result;
							_this.initRoomNum();
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.data.error_msg);
						}
					},
					error: function(err) {
						layer.msg("网络错误");
					}
				});
			},
			// 初始化包厢号
			initRoomNum: function() {
				let _this = this;
				$(_this.$refs.room_num).bsSuggest("destroy");
				$(_this.$refs.room_num).bsSuggest({
					data: {
						value: _this.roomNumData
					},
					ignorecase: true,
					showHeader: false,
					showBtn: false,
					delayUntilKeyup: true,
					effectiveFields: ["name"],
					idField: "id",
					keyField: "name"
				}).on('onSetSelectValue', function(e, keyword, data) {

				});
			},
			// 查询
			clkQuery: function() {
				this.innitTable();
			},
			// 配送列表
			innitTable: function() {
                let _this = this;
				$(_this.$refs.distribt_list).bootstrapTable("destroy");
                $(_this.$refs.distribt_list).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "listorder",
                        title: "优先级",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "shop_name",
                        title: "适用门店",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "name",
                        title: "规则名称",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "room_info",
                        title: "适用包厢",
                        width: "8%",
                        valign: "middle",
                        class: "room-info-td",
                        formatter: function(value, row, index) {
                            if(row.use_all_room == '1') {
                                return '全部包厢'
                            } else {
                                return row.room_info
                            }
                        }
                    }, {
                        field: "use_date",
                        title: "使用日期",
                        width: "8%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                        	if(row.use_every_day == '1') {
                        		return '每天'
                        	} else {
                            	return row.use_start_date + '-' + row.use_end_date
                        	}
                        }
                    }, {
                        field: "use_time",
                        title: "使用时间",
                        width: "8%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            if(row.use_all_day == '1') {
                            	return '全天';
                            } else {
                                return row.use_start_time + '-' + row.use_end_time;
                            }
                        }
                    }, {
                        field: "week_cycle_info",
                        title: "适用星期几",
                        width: "9%",
                        valign: "middle"
                    }, {
                        field: "goods_name",
                        title: "适用商品",
                        width: "9%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        field: "purchase_limit",
                        title: "配送<br />起购数",
                        width: "7%",
                        valign: "middle"
                    }, {
                        field: "type_name",
                        title: "配送方式",
                        width: "8%",
                        valign: "middle"
                    }, {
                        field: "present_goods_str",
                        title: "配送商品",
                        width: "9%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return value.length > '14' ? value.slice(0, 14) + '...' : value
                        }
                    }, {
                        title: "操作",
                        width: "10%",
                        valign: "middle",
                        events: {
                            'click .edit': function(e, value, row) {
                                _this.dist_time = '';
                                _this.addModify = 2;
                                _this.add_header = '修改配送规则';
                                _this.getDetail(row.id);
                                _this.showList = false;
                                _this.showEdit = true;
                            },
                            'click .status': function(e, value, row) {
                                _this.cgStatus(row.id);
                            },
                            'click .detail': function(e, value, row) {
                                _this.addModify = 3;
                                _this.add_header = '配送规则详情';
                                _this.getDetail(row.id);
                                _this.showList = false;
                                _this.showEdit = true;
                            },
                            'click .del': function(e, value, row) {
                                layer.confirm('删除后不可恢复，确定删除吗？', {
                                    btn: ['确定', '取消']
                                }, function() {
                                    _this.cgStatus(row.id, '-2');
                                });
                            },
                            'click .copyAdd': function(e, value, row) {
                                _this.dist_time = '';
                                _this.addModify = 4;
                                _this.add_header = '新增配送规则';
                                _this.getDetail(row.id);
                                _this.showList = false;
                                _this.showEdit = true;
                            },
                        },
                        formatter: function(value, row, index) {
                            let statusText = (row.status == 1) ? '禁用' : '启用';

							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								if(v.name == '状态') {
									op_html += '<span class="'+ v.cls +'">'+ statusText  +'</span>';
								} else {
									op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>';
								}
							});
							return op_html;
                        }
                    }],
                });
            },
            // 表格数据
            getList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.shop).val(),
                    room_id = $(_this.$refs.room_num).attr("data-id"),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": pageNumber,
                            "page_size": params.data.limit,
                            "start_date": _this.startTime,
                            "end_date": _this.endTime,
                            "shop_id": shop_id || "",
                            "room_id": room_id,
                            "type": $.trim($(_this.$refs.distribt_type).val()),
                            "status": $.trim($(_this.$refs.distribt_status).val()),
							"name": _this.list_rule_name,
                            "goods_name": _this.list_right_name,
							"present_goods_name": _this.list_distr_name
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PresentGoodsRule/getList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.count,
                                rows: data.response.result.data
                            });
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 禁用/启用、删除
            cgStatus: function(id, status) {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "id": id
                        }
                    },
                    "comment": ""
                };
                if(status == '-2') {
                	console.log(status);
                    datas['request']['param']['status'] = status;
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PresentGoodsRule/setStatus",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $(_this.$refs.distribt_list).bootstrapTable("refresh");
                            layer.msg(data.response.error_msg);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 打开新增
            addDistribt: function() {
				var _this = this;

				$(_this.$refs.add_priority).prop('disabled', false);
				$(_this.$refs.add_rule).prop('disabled', false);
				$(_this.$refs.distribt_min).prop('disabled', false);
				$(_this.$refs.add_distribt_type).prop('disabled', false);
				$(_this.$refs.distribt_gooods).prop('disabled', false);
				$(_this.$refs.add_shop).prop('disabled', false);
				$(_this.$refs.right_goods).prop('disabled', false);
				$(_this.$refs.add_shop).val("").trigger('change');
				// 全部包厢
				let shopid = $(_this.$refs.add_shop).val();
				_this.room_type = 1;
				_this.getAllRoomByArea(shopid, 1);
				_this.room_checkboxModel = [];
                _this.room_detailcheckboxdata.forEach(function(item) {
                    _this.room_checkboxModel.push(item.id);
                });
				// _this.box_allcheck = true;
				$(_this.$refs.distribt_box_txt).prop('disabled', false);
				_this.distribt_box_txt = '全部包厢';
				_this.use_all_room = '1';
				// 每天
				$(_this.$refs.add_play_date).prop('disabled', false);
				$(_this.$refs.add_play_time).prop('disabled', false);
				_this.add_play_date = '每天';
				_this.add_play_dateModel = '1';

				// _this.room_checkboxModel = [];
				_this.add_rule = '';
				_this.add_priority = '';
				_this.detail_list = [];
				_this.distribt_min = '';
				_this.distb_detail_list = [];
				// 使用时间
				_this.time_start_time = '00:00';
				_this.time_end_time = '00:00';
				_this.dist_time = '1'
				// 星期全选
				let texts = [];
				_this.week = "";
				_this.week_checkboxModel = [];
				_this.week_checkboxData.forEach(function(item) {
					texts.push(item.name);
					_this.week_checkboxModel.push(item.id);
				});
				_this.week = texts.join(",");
				$(_this.$refs.week).prop('disabled', false);
				_this.distribt_type_id = '';
				_this.distb_all = '';
				$(_this.$refs.right_goods_table).bootstrapTable("destroy");
				$(_this.$refs.distb_table).bootstrapTable("destroy");
				_this.distribt_gooods = [];
				_this.right_goods = [];
				$('.page-right-goods-txt p').show();
				_this.remenberNum.day = [];
				_this.remenberNum.day_str = [];
				// _this.add_play_time = "";
				$(".week_popup-wrap input").prop("checked", false);
				$(_this.$refs.starthour).val('00').trigger('change');
				$(_this.$refs.startseconds).val('00').trigger('change');
				$(_this.$refs.stophour).val('00').trigger('change');
				$(_this.$refs.stopseconds).val('00').trigger('change');
				_this.selectTime();

				_this.addModify = 1;
				_this.add_header = '新增配送规则';
				_this.showEdit = true;
				_this.showList = false;

				_this.objClass = {
					selection_clear: true,
					visi_hid: false
				};

				_this.distribt_type_id = '1';
				_this.distribt_type_name = '固定配送';
				$(".type-choose input").eq(0).prop("checked", 'checked');

				_this.add_startDate = "";
				_this.add_endDate = "";
				_this.selDate();
			},
			// 页面提示语
			hint_language: function(e) {
				var contents="<span class='dots'>·</span>"+$(e.currentTarget).attr("titles");
				layer.tips(contents, (e.currentTarget), {
					skin: 'hint_language_tip',
					tips: [2, '#fff'],
					time: 2000000,
				});
			},
			//关闭提示语
			close_hint_language: function() {
				layer.closeAll('tips');
			},
			selDate: function() {
				let _this = this;
				$(_this.$refs.add_play_date).daterangepicker({
					parentEl: '.distribt-usedate-wrap',
					drops: 'up',
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
				}, function(start, end, label) {
					_this.add_startDate = start.format('YYYY-MM-DD');
					_this.add_endDate = end.format('YYYY-MM-DD');
					if($(".usedate-everyday input").val() == "1") {
						_this.add_play_date = '每天';
						_this.add_play_dateModel = 1;
					} else {
						_this.add_play_date = _this.add_startDate + ' ~ ' + _this.add_endDate;
						_this.add_play_dateModel = -1;
					}
				});
				$(".distribt-usedate-wrap .daterangepicker:last").find(".ranges").prepend(
					'<div class="usedate-everyday">' +
						'<input type="checkbox" />' +
						'<label>每天</label>' +
					'</div>'
				);
				$(".usedate-everyday input").click(function() {
					if($(this).val() == "1") {
						$(this).prop("checked", false);
						$(this).val('');
					} else {
						$(this).prop("checked", true);
						$(this).val('1');
					}
				});
			},
			// 清空
			clear_input: function(name) {
				if(name == "right_goods") {
					this.right_goods = [];
				} else if(name == "distribt_gooods") {
					this.distribt_gooods = [];
				} else if(name == "add_play_time") {
					this.add_play_time = "";
				}
			},
			// 新增页门店数据
			addShopData: function() {
				var _this = this;
				$(_this.$refs.add_shop).html("");
				$(_this.$refs.add_shop).select2({
					data: _this.add_shop_data,
					allowClear: false,
					minimumResultsForSearch: -1,
					language: "zh-CN",
					width: '100%'
				}).on("select2:select", function(e) {
					_this.distribt_box_txt = '';
					_this.box_allcheck = false;
					_this.room_checkboxModel = [];

					_this.right_goods = [];
					_this.detail_list = [];
					$(_this.$refs.right_goods_table).bootstrapTable("destroy");
					_this.distribt_gooods = [];
					_this.distb_all = '';
					_this.distb_detail_list = [];
					$(_this.$refs.distb_table).bootstrapTable("destroy");
					// $(_this.$refs.printer_add_area).val("");
					// $(_this.$refs.printer_add_area).removeClass("canselect");
					// $(_this.$refs.printer_room_area).val("");
					// $(_this.$refs.printer_room_area).removeClass("canselect");
					// $(_this.$refs.add_stock_name).prop("disabled", false);
					// _this.getstockdata(e.params.data.id, 'false', "");
				});
			},
			// 点击选择适用商品
			right_goods_fun: function() {
				// $('#page-right-goods').
				this.showRight = true;
				this.showEdit = false;
			},
			backToEdit() {
				this.showDistb = false;
				this.showEdit = true;
			},
			// 点击“添加商品”
			addRightGoods: function() {
				const _this = this;

				_this.goodsType_list = [{
					id: "0",
					text: "全部"
				}, {
					id: "-1",
					text: "开房套餐",
					sign: '-1'
				}, {
					id: "-2",
					text: "商品套餐",
					sign: '-2',
					sign_id: '0'
				}];
				$(_this.$refs.goodtype).val('').trigger('change');
				_this.goods_type_sign = '';
				_this.getCusPakage();
				_this.innitGoodsTable($(_this.$refs.add_shop).val());
				layer.open({
					type: 1,
					title: '添加商品/商品套餐',
					skin: 'layui-layer-rim', //加上边框
					area: ['700px', '550px'], //宽高
					content: $(_this.$refs.addgoods)
				});
			},
			getCusPakage() {
				const _this = this;

				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.goodsType_list.push({
								id: '-2' + v.id,
								text: v.name,
								sign: '-2',
								sign_id: v.id
							});
						});
						_this.innitSelect();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			// 初始化商品类型选择框
			innitSelect: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							$.each(data.response.result.data, function(k, v) {
								_this.goodsType_list.push({
									id: v.id,
									text: v.name
								});
							});
							$(_this.$refs.goodtype).select2({
								data: _this.goodsType_list,
								width: '190px'
							}).on("select2:select", function(e) {
								_this.goods_type_sign = e.params.data.sign;
								if(_this.goods_type_sign == '-1') {
									_this.innitBoxPackageTable($(_this.$refs.add_shop).val());
								} else if(_this.goods_type_sign == '-2') {
									_this.goods_type_sign_id = e.params.data.sign_id;
									_this.innitGoodsPackageTable($(_this.$refs.add_shop).val());
								} else {
									_this.innitGoodsTable($(_this.$refs.add_shop).val());
								}
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化添加进货商品弹窗的商品列表
			innitGoodsTable: function(shop_id) {
				let _this = this;
				$(_this.$refs.goodslist).bootstrapTable('destroy');
				$(_this.$refs.goodslist).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品列表
			getGoodsList: function(params, shop_id) {
				let _this = this,
					goods_type = $(_this.$refs.goodtype).val(),
					goods_name = $(_this.$refs.goodname).val(),
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": goods_type,
							"goods_name": goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化商品套餐列表
			innitGoodsPackageTable: function(shop_id) {
				let _this = this;
				$(_this.$refs.goodslist).bootstrapTable('destroy');
				$(_this.$refs.goodslist).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsPackageList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "merchant_id",
						title: "商品套餐id",
						visible: false
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '商品套餐'
						}
					}, {
						field: "name",
						title: "名称"
					}, {
						field: "package_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品套餐列表
			getGoodsPackageList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": _this.goods_type_sign_id,
							"name": $(_this.$refs.goodname).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 初始化开房套餐列表
			innitBoxPackageTable: function(shop_id) {
				let _this = this;
				$(_this.$refs.goodslist).bootstrapTable('destroy');
				$(_this.$refs.goodslist).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getBoxPackageList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "id",
						title: "开房套餐id",
						visible: false
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '开房套餐'
						}
					}, {
						field: "package_name",
						title: "名称",
						formatter: function(value, row, index) {
							return row.package_name + '(' + row.room_type_name + ')';
						}
					}, {
						field: "box_unit_name",
						title: "单位",
						formatter: function(value, row, index) {
							return '份'
						}
					}],
					clickToSelect: true
				});
			},
			// 获取开房套餐列表
			getBoxPackageList: function(params, shop_id) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"package_name": $(_this.$refs.goodname).val()
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "RoomPackage/getPackagePriceList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

			// 点击添加商品弹窗的“查询”按钮
			queryGoods: function() {
				const _this = this;
				if(_this.goods_type_sign == '-1') {
					_this.innitBoxPackageTable($(_this.$refs.add_shop).val());
				} else if(_this.goods_type_sign == '-2') {
					_this.innitGoodsPackageTable($(_this.$refs.add_shop).val());
				} else {
					_this.innitGoodsTable($(_this.$refs.add_shop).val());
				}
			},
			// 点击添加进货商品弹窗的“保存”按钮
			saveGoods: function() {
				const _this = this;
				$.map($(_this.$refs.goodslist).bootstrapTable('getSelections'), function(row) {
					for(let i = 0; i < _this.detail_list.length; i++) {
						if(_this.detail_list[i].goods_id == row.id) {
							layer.msg("商品已存在");
							return;
						}
					}
					if(_this.goods_type_sign == '-1') {
						_this.detail_list.push({ goods_id: row.id, goods_type_name: '开房套餐', good_img: row.img_url, goods_name: row.package_name + '(' + row.room_type_name + ')', goods_unit_name: '份', cost_price: row.price, discount_price: row.actual_price, goods_type: '-1', goods_acronym: '' });
					} else if(_this.goods_type_sign == '-2') {
						_this.detail_list.push({ goods_id: row.id, goods_type_name: '商品套餐', good_img: row.img_url, goods_name: row.name, goods_unit_name: row.package_unit_name, cost_price: row.price, discount_price: row.actual_price, goods_type: '0', goods_acronym: '', status: '1' });
					} else {
						_this.detail_list.push({ goods_id: row.id, goods_type_name: row.goods_type_name, good_img: row.good_img, goods_name: row.goods_name, goods_unit_name: row.goods_unit_name, cost_price: row.cost_price, discount_price: row.discount_price, goods_type: row.goods_type, goods_acronym: row.acronym });
					}
					$('.page-right-goods-txt p').hide();
					layer.msg("成功添加商品");
				});
				// _this.showDetailTable = true;
				$(_this.$refs.right_goods_table).bootstrapTable("destroy");
				_this.initRightGoods();
				// //更新价格
				// _this.updatePrice();
			},
			// 初始化适用商品表格
			initRightGoods: function() {
				let _this = this;
				$(_this.$refs.right_goods_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_type_name",
						title: "商品类型",
						width: "10%",
						valign: "middle"
					}, {
						field: "good_img",
						title: "商品图片",
						width: "15%",
						valign: "middle",
						formatter: function(value, row, index) {
							return '<img src="'+ row.good_img +'" class="good-img" />'
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: "15%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "10%",
						valign: "middle"
					}, {
						field: "cost_price",
						title: "原价",
						width: "10%",
						valign: "middle"
					}, {
						field: "discount_price",
						title: "优惠价",
						width: "10%",
						valign: "middle"
					}, {
						field: "op",
						title: "操作",
						width: "10%",
						valign: "middle",
						events: {
							'click .delete': function(e, value, row, index) {
								layer.confirm("确定删除该商品吗？", {
									btn: ['确定', '取消'], //按钮
								}, function() {
									let depositeData = [];
									for(let i = 0; i < _this.detail_list.length; i++) {
										if(_this.detail_list[i].goods_id != row.goods_id) {
											depositeData.push(_this.detail_list[i]);
										}
									}
									_this.detail_list = depositeData;
									$(_this.$refs.right_goods_table).bootstrapTable("destroy");
									_this.initRightGoods();
									layer.closeAll();
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-orange delete">删除</span>'
						}
					}],
					data: _this.detail_list
				});
			},
			// 确定适用商品
			submitRight: function() {
				let _this = this;
				_this.right_goods = [];
				$.each(_this.detail_list, function(k, v) {
					_this.right_goods.push(v.goods_name);
				});
				_this.showRight = false;
				_this.showEdit = true;
			},
			// 点击选择配送方式
			addTypeSel: function() {
				let _this = this;
				if(_this.operateType == "edit") {

				} else {
					layer.open({
						type: 1,
						title: '配送方式',
						area: ['430px', '300px'], // 宽高
						content: $('.type_popup')
					});
				}
			},
			sureChooseType() {
				var _this = this;

				// _this.editNameParams.type = "";
				_this.distribt_type_id = '';
				_this.distribt_type_name = '';

				for(let i = 0; i < $(".type-choose input").length; i++) {
					if($(".type-choose input").eq(i).prop("checked") == true) {
						_this.distribt_type_id = i + 1;
						_this.distribt_type_name = $(".type-choose input").eq(i).val();
					}
				}
				// if(_this.editNameParams.type == "2" || _this.editNameParams.type == "4") {
				// 	_this.isNeed = true;
				// } else {
				// 	_this.isNeed = false;
				// 	_this.packageDetail_table = [];
				// 	$(_this.$refs.packageDetail_table).bootstrapTable("destroy");
				// 	// _this.initDetailTable();
				// }
				layer.closeAll();
			},
			// 关闭弹窗
			closelayer: function() {
				layer.closeAll();
			},

			// 点击选择配送商品
			distribt_gooods_fun: function() {
				let all_num = 0;
				if(this.distribt_type_name == '固定配送') {
					$(this.$refs.distb_all).prop('disabled', true);

					$.each(this.distb_detail_list, function(k, v) {
						if(v.present_default != '') {
							all_num += parseInt(v.present_default);
						}
					});
					this.distb_all = all_num;
				} else if(this.distribt_type_name == '手工配送') {
					$(this.$refs.distb_all).prop('disabled', false);
					if(this.addModify != "2") {
						this.distb_all = '';
					}
				}
				this.showEdit = false;
				this.showDistb = true;
			},
			// 点击添加配送商品
			addDistbGoods: function() {
				var _this = this;
				_this.distb_goodstype == [];
				$(_this.$refs.distbGoodtype).val('').trigger('change');
				_this.innitDistbtSelect();
				_this.innitDistbGoodsTable($(_this.$refs.add_shop).val());
				layer.open({
					type: 1,
					title: '添加商品',
					skin: 'layui-layer-rim', //加上边框
					area: ['700px', '550px'], //宽高
					content: $(_this.$refs.addDistbGoods)
				});
			},
			// 初始化商品类型选择框
			innitDistbtSelect: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							_this.distb_goodstype.push({
								id: "0",
								text: "全部"
							});
							$.each(data.response.result.data, function(k, v) {
								_this.distb_goodstype.push({
									id: v.id,
									text: v.name
								});
							});
							$(_this.$refs.distbGoodtype).select2({
								allowClear: true,
								data: _this.distb_goodstype,
								width: '190px'
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 初始化添加进货商品弹窗的商品列表
			innitDistbGoodsTable: function(shop_id) {
				let _this = this;
				$(_this.$refs.distbGoodslist).bootstrapTable('destroy');
				$(_this.$refs.distbGoodslist).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getDistbGoodsList(params, shop_id);
					},
					sidePagination: "server",
					columns: [{
						checkbox: true,
						title: "全选"
					}, {
						field: "merchant_goods_id",
						title: "商品id",
						visible: false
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			// 获取商品列表
			getDistbGoodsList: function(params, shop_id) {
				let _this = this,
					goods_type = $(_this.$refs.distbGoodtype).val(),
					goods_name = $(_this.$refs.distbGoodname).val(),
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": shop_id,
							"goods_type": goods_type,
							"goods_name": goods_name,
							"status": '1'
							// "is_sell": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击添加商品弹窗的“查询”按钮
			distbQueryGoods: function() {
				$(this.$refs.distbGoodslist).bootstrapTable("destroy");
				this.innitDistbGoodsTable($(this.$refs.add_shop).val());
			},
			// 点击添加进货商品弹窗的“保存”按钮
			saveDistbGoods: function() {
				let _this = this;
				$.map($(_this.$refs.distbGoodslist).bootstrapTable('getSelections'), function(row) {
					for(let i = 0; i < _this.distb_detail_list.length; i++) {
						if(_this.distb_detail_list[i].goods_id == row.id) {
							layer.msg("商品已存在");
							return;
						}
					}
					_this.distb_detail_list.push({ goods_id: row.id, goods_type_name: row.goods_type_name, good_img: row.good_img, goods_name: row.goods_name, goods_unit_name: row.goods_unit_name, present_default: '', present_max: '', goods_type: row.goods_type, goods_unit: row.goods_unit });
					layer.msg("成功添加商品");
				});
				// _this.showDetailTable = true;
				$(_this.$refs.distb_table).bootstrapTable("destroy");
				_this.initDistbGoods();
				// //更新价格
				// _this.updatePrice();
			},
			// 初始化配送商品表格
			initDistbGoods: function() {
				let _this = this;
				$(_this.$refs.distb_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_type_name",
						title: "商品类型",
						width: "10%",
						valign: "middle"
					}, {
						field: "good_img",
						title: "商品图片",
						width: "15%",
						valign: "middle",
						formatter: function(value, row, index) {
							return '<img src="'+ row.good_img +'" class="good-img" />'
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: "15%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "10%",
						valign: "middle"
					}, {
						field: "present_default",
						title: "默认数量",
						width: "10%",
						valign: "middle",
						events: {
							'blur .present-default': function(e, value, row, index) {
								if($.trim($(this).val()) < 0) {
									layer.msg('默认数量不能为负数');
									$(this).val('');
									return;
								}
								// if(_this.distb_detail_list[index].present_max != '' && $.trim($(this).val()) > _this.distb_detail_list[index].present_max) {
								// 	layer.msg('默认数量不能大于最大配送数量');
								// 	$(this).val('');
								// 	return;
								// }
								_this.distb_detail_list[index] = {
									"goods_id": _this.distb_detail_list[index].goods_id,
									"goods_type_name": _this.distb_detail_list[index].goods_type_name,
									"good_img": _this.distb_detail_list[index].good_img,
									"goods_name": _this.distb_detail_list[index].goods_name,
									"goods_unit_name": _this.distb_detail_list[index].goods_unit_name,
									"present_default": $.trim($(this).val()),
									"present_max": _this.distb_detail_list[index].present_max,
									"goods_type": _this.distb_detail_list[index].goods_type,
									"goods_unit": _this.distb_detail_list[index].goods_unit,
								};
								
								let all_num = 0;
								$.each(_this.distb_detail_list, function(k, v) {
									if(v.present_default != '') {
										all_num += parseInt(v.present_default);
									}
								});
								if(_this.distribt_type_name == '固定配送') {
									_this.distb_all = all_num;
								} else {
									if(parseInt(_this.distb_all) < all_num) {
										_this.distb_all = all_num;
									}
								}
							}
						},
						formatter: function(value, row, index) {
							return [
								'<input type="text" placeholder="请输入默认数量" class="present-default" value="'+ row.present_default +'" />'
							].join('');
						}
					}, {
						field: "present_max",
						title: "最大配送数",
						width: "10%",
						valign: "middle",
						events: {
							'blur .present-max': function (e, value, row, index) {
								if($.trim($(this).val()) < 0) {
									layer.msg('最大配送数不能为负数');
									$(this).val('');
									return;
								}
								// if($.trim($(this).val()) < _this.distb_detail_list[index].present_default) {
								// 	layer.msg('默认数量不能大于最大配送数量');
								// 	$(this).val('');
								// 	return;
								// }
                                _this.distb_detail_list[index] = {
                                    "goods_id": _this.distb_detail_list[index].goods_id,
                                    "goods_type_name": _this.distb_detail_list[index].goods_type_name,
                                    "good_img": _this.distb_detail_list[index].good_img,
                                    "goods_name": _this.distb_detail_list[index].goods_name,
                                    "goods_unit_name": _this.distb_detail_list[index].goods_unit_name,
                                    "present_default": _this.distb_detail_list[index].present_default,
                                    "present_max": $.trim($(this).val()),
                                    "goods_type": _this.distb_detail_list[index].goods_type,
                                    "goods_unit": _this.distb_detail_list[index].goods_unit,
                                };
                            }
						},
						formatter: function(value, row, index) {
							return [
								'<input type="text" placeholder="请输入最大配送数" class="present-max" value="'+ row.present_max +'" />'
							].join('');
						}
					}, {
						field: "op",
						title: "操作",
						width: "10%",
						valign: "middle",
						events: {
							'click .delete': function(e, value, row, index) {
								layer.confirm("确定删除该商品吗？", {
									btn: ['确定', '取消'], //按钮
								}, function() {
									let depositeData = [];
									for(let i = 0; i < _this.distb_detail_list.length; i++) {
										if(_this.distb_detail_list[i].goods_id != row.goods_id) {
											depositeData.push(_this.distb_detail_list[i]);
										}
									}
									_this.distb_detail_list = depositeData;
									$(_this.$refs.distb_table).bootstrapTable("destroy");
									_this.initDistbGoods();
									layer.closeAll();
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-orange delete">删除</span>'
						}
					}],
					data: _this.distb_detail_list
				});
			},
			// 确定配送商品
			submitDistb: function() {
				let _this = this;
				_this.distribt_gooods = [];
				if(_this.distb_detail_list.length == 0) {
					layer.msg('请添加配送商品');
				} else {
					$.each(_this.distb_detail_list, function(k, v) {
						_this.distribt_gooods.push(v.goods_name);
						if(_this.distb_detail_list[k].present_default == '') {
							layer.msg('请填写配送商品的默认数量');
							return false;
						} else if(_this.distb_detail_list[k].present_max == '') {
							layer.msg('请填写配送商品的最大配送数');
							return false;
						} else if(parseInt(_this.distb_detail_list[k].present_max) < _this.distb_detail_list[k].present_default) {
							layer.msg('默认数量不能大于最大配送数量');
							return false;
						} else if(k < _this.distb_detail_list.length - 1) {
							return;
						} else {
							_this.showDistb = false;
							_this.showEdit = true;
						}
					});
				}
			},
			// 检索已添加配送商品
			queryAlreadyAddGoods() {
				if (this.alreadyAddName == '') {
					this.showFilterAlreadyAddGoods = false
				}else {
					this.filterAlreadyAddGoods = []
					this.distb_detail_list.forEach(item => {
						if (item.goods_name.includes(this.alreadyAddName)) {
							this.filterAlreadyAddGoods.push(item)
						}
					})
					$(this.$refs.filter_table).bootstrapTable("destroy");
					this.initFilterAlreadyAddGoods()
					this.showFilterAlreadyAddGoods = true
				}
			},
			// 初始化配送商品检索结果表格
			initFilterAlreadyAddGoods: function() {
				let _this = this;
				$(_this.$refs.filter_table).bootstrapTable({
					pageNumber: 1,
					pageSize: 10,
					pageList: [],
					pagination: true,
					columns: [{
						field: "goods_type_name",
						title: "商品类型",
						width: "10%",
						valign: "middle"
					}, {
						field: "good_img",
						title: "商品图片",
						width: "15%",
						valign: "middle",
						formatter: function(value, row, index) {
							return '<img src="'+ row.good_img +'" class="good-img" />'
						}
					}, {
						field: "goods_name",
						title: "商品名称",
						width: "15%",
						valign: "middle"
					}, {
						field: "goods_unit_name",
						title: "商品单位",
						width: "10%",
						valign: "middle"
					}, {
						field: "present_default",
						title: "默认数量",
						width: "10%",
						valign: "middle",
						events: {
							'blur .present-default': function(e, value, row, index) {
								if($.trim($(this).val()) < 0) {
									layer.msg('默认数量不能为负数');
									$(this).val('');
									return;
								}
								
								_this.filterAlreadyAddGoods[index] = {
									"goods_id": _this.filterAlreadyAddGoods[index].goods_id,
									"goods_type_name": _this.filterAlreadyAddGoods[index].goods_type_name,
									"good_img": _this.filterAlreadyAddGoods[index].good_img,
									"goods_name": _this.filterAlreadyAddGoods[index].goods_name,
									"goods_unit_name": _this.filterAlreadyAddGoods[index].goods_unit_name,
									"present_default": $.trim($(this).val()),
									"present_max": _this.filterAlreadyAddGoods[index].present_max,
									"goods_type": _this.filterAlreadyAddGoods[index].goods_type,
									"goods_unit": _this.filterAlreadyAddGoods[index].goods_unit,
								};

								let origin_index = _this.distb_detail_list.findIndex(item => item.goods_id == row.goods_id)
								_this.distb_detail_list[origin_index] = {
                                    "goods_id": _this.distb_detail_list[origin_index].goods_id,
                                    "goods_type_name": _this.distb_detail_list[origin_index].goods_type_name,
                                    "good_img": _this.distb_detail_list[origin_index].good_img,
                                    "goods_name": _this.distb_detail_list[origin_index].goods_name,
                                    "goods_unit_name": _this.distb_detail_list[origin_index].goods_unit_name,
                                    "present_default": $.trim($(this).val()),
                                    "present_max": _this.distb_detail_list[origin_index].present_max,
                                    "goods_type": _this.distb_detail_list[origin_index].goods_type,
                                    "goods_unit": _this.distb_detail_list[origin_index].goods_unit,
                                };
                                $(_this.$refs.distb_table).bootstrapTable("updateRow", { index: origin_index, row: _this.distb_detail_list[origin_index] })
								
								let all_num = 0;
								$.each(_this.distb_detail_list, function(k, v) {
									if(v.present_default != '') {
										all_num += parseInt(v.present_default);
									}
								});
								if(_this.distribt_type_name == '固定配送') {
									_this.distb_all = all_num;
								} else {
									if(parseInt(_this.distb_all) < all_num) {
										_this.distb_all = all_num;
									}
								}
							}
						},
						formatter: function(value, row, index) {
							return [
								'<input type="text" placeholder="请输入默认数量" class="present-default" value="'+ row.present_default +'" />'
							].join('');
						}
					}, {
						field: "present_max",
						title: "最大配送数",
						width: "10%",
						valign: "middle",
						events: {
							'blur .present-max': function (e, value, row, index) {
								if($.trim($(this).val()) < 0) {
									layer.msg('最大配送数不能为负数');
									$(this).val('');
									return;
								}
                                _this.filterAlreadyAddGoods[index] = {
                                    "goods_id": _this.filterAlreadyAddGoods[index].goods_id,
                                    "goods_type_name": _this.filterAlreadyAddGoods[index].goods_type_name,
                                    "good_img": _this.filterAlreadyAddGoods[index].good_img,
                                    "goods_name": _this.filterAlreadyAddGoods[index].goods_name,
                                    "goods_unit_name": _this.filterAlreadyAddGoods[index].goods_unit_name,
                                    "present_default": _this.filterAlreadyAddGoods[index].present_default,
                                    "present_max": $.trim($(this).val()),
                                    "goods_type": _this.filterAlreadyAddGoods[index].goods_type,
                                    "goods_unit": _this.filterAlreadyAddGoods[index].goods_unit,
                                };

                                let origin_index = _this.distb_detail_list.findIndex(item => item.goods_id == row.goods_id)
								_this.distb_detail_list[origin_index] = {
                                    "goods_id": _this.distb_detail_list[origin_index].goods_id,
                                    "goods_type_name": _this.distb_detail_list[origin_index].goods_type_name,
                                    "good_img": _this.distb_detail_list[origin_index].good_img,
                                    "goods_name": _this.distb_detail_list[origin_index].goods_name,
                                    "goods_unit_name": _this.distb_detail_list[origin_index].goods_unit_name,
                                    "present_default":_this.distb_detail_list[origin_index].present_default,
                                    "present_max": $.trim($(this).val()),
                                    "goods_type": _this.distb_detail_list[origin_index].goods_type,
                                    "goods_unit": _this.distb_detail_list[origin_index].goods_unit,
                                };
                                $(_this.$refs.distb_table).bootstrapTable("updateRow", { index: origin_index, row: _this.distb_detail_list[origin_index] })
                            }
						},
						formatter: function(value, row, index) {
							return [
								'<input type="text" placeholder="请输入最大配送数" class="present-max" value="'+ row.present_max +'" />'
							].join('');
						}
					}, {
						field: "op",
						title: "操作",
						width: "10%",
						valign: "middle",
						events: {
							'click .delete': function(e, value, row, index) {
								layer.confirm("确定删除该商品吗？", {
									btn: ['确定', '取消'], //按钮
								}, function() {
									let depositeData = [];
									for(let i = 0; i < _this.distb_detail_list.length; i++) {
										if(_this.distb_detail_list[i].goods_id != row.goods_id) {
											depositeData.push(_this.distb_detail_list[i]);
										}
									}
									_this.distb_detail_list = depositeData;
									$(_this.$refs.distb_table).bootstrapTable("destroy");
									_this.initDistbGoods();

									let d_index = _this.filterAlreadyAddGoods.findIndex(item => item.goods_id == row.goods_id)
									_this.filterAlreadyAddGoods.splice(d_index, 1)
									$(_this.$refs.filter_table).bootstrapTable("destroy");
									_this.initFilterAlreadyAddGoods()
									layer.closeAll();
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-orange delete">删除</span>'
						}
					}],
					data: _this.filterAlreadyAddGoods
				});
			},



			// 点击选择包厢号
			go_distribt_box: function(e) {
				if(!$(e.currentTarget).hasClass('canselect')){
					var _this = this;
					// _this.distribt_box_txt = [];
					// _this.c_room_all = _this.box_allcheck;
					_this.c_room_type = _this.room_type;
					_this.c_room_checkboxModel = _this.room_checkboxModel;

					let shopid = $(_this.$refs.add_shop).val();

					_this.getAllRoomByArea(shopid, _this.room_type);

					_this.c_box_allcheck = _this.box_allcheck;

					_this.showEdit = false;
					_this.showbox = true;
				}
			},
			// 包厢号数据
			getAllRoomByArea: function(shopid, type) {
				var _this = this;
				var datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"type": type,
							"shop_id": shopid
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getAllRoomByArea",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.room_checkboxdata = data['response']['result'];
							let newarray = [];
							$.each(data['response']['result'], function(k, v) {
								$.each(v.room, function(m, n) {
									newarray.push(n);
								});
							});
							_this.room_detailcheckboxdata = newarray;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {}
				});
			},
			// 切换
			roomTypeCg: function(type) {
				let shopid = $(this.$refs.add_shop).val();
				$('.distb-room-type li').removeClass('distb-room-sel');
				$('.distb-room-type li').eq(type - 1).addClass('distb-room-sel');

				this.room_checkboxModel = [];
				this.room_type = type;
				// _this.distribt_box_txt = '';
				// _this.use_all_room = '-1';

				this.getAllRoomByArea(shopid, type);
			},
			// 全选
            roomAllcheck: function() {
                var _this = this;
                _this.box_allcheck = _this.c_box_allcheck;
                if(!_this.box_allcheck) { // 实现全选
                    _this.room_checkboxModel = [];
                    _this.room_detailcheckboxdata.forEach(function(item) {
                        _this.room_checkboxModel.push(item.id);
                    });
                } else { // 实现反选
                    this.room_checkboxModel = [];
                }
            },
            // 楼层全选/反选
            roomFlr: function(id, index) {
                let _this = this;
                
                _this.room_flrModel = _this.c_room_flrModel;
                if(_this.room_flrModel.indexOf(id) == -1) {
                    $.each(_this.room_checkboxdata[index].room, function(k, v) {
                        if(_this.room_checkboxModel.indexOf(v.id) == -1) {
                            _this.room_checkboxModel.push(v.id);
                        }
                    });
                } else {
                    $.each(_this.room_checkboxdata[index].room, function(k, v) {
                        let index = '';
                        index = _this.room_checkboxModel.indexOf(v.id);
                        if(index != -1) {
                            _this.room_checkboxModel.splice(index, 1);
                        }
                    });
                }
            },
			// 确定
			roomboxokFun: function() {
				var _this = this;
				// var texts = '';
				// _this.distribt_box_txt = [];
				if(_this.box_allcheck) {
					_this.distribt_box_txt = '全部包厢';
					_this.use_all_room = '1';
				} else {
					let texts = [];
					_this.room_detailcheckboxdata.forEach(function(item) {
						_this.room_checkboxModel.forEach(function(sub) {
							if(item.id == sub) {
								texts.push(item.name);
							}
						});
					});
                    _this.distribt_box_txt = texts.join(",");
					_this.use_all_room = '-1';
				}
				_this.showEdit = true;
				_this.showbox = false;
			},
			// 返回
			roomboxbackFun: function() {
				// this.box_allcheck = this.c_room_all;
				this.room_type = this.c_room_type;
				this.room_checkboxModel = this.c_room_checkboxModel;
				console.log(this.c_room_checkboxModel);
				$('.distb-room-type li').removeClass('distb-room-sel');
				$('.distb-room-type li').eq(this.room_type - 1).addClass('distb-room-sel');
				this.showEdit = true;
				this.showbox = false;

				// let shopid = $(this.$refs.add_shop).val();
				// this.getAllRoomByArea(shopid, this.room_type);
			},


			// 点击选择时间
			timePop: function() {
				let _this = this;
				let c_dist_time = _this.dist_time;
				if(_this.dist_time == '1') {
					$(_this.$refs.starthour).val('00').trigger('change');
					$(_this.$refs.startseconds).val('00').trigger('change');
					$(_this.$refs.stophour).val('00').trigger('change');
					$(_this.$refs.stopseconds).val('00').trigger('change');
				} else {
					$(_this.$refs.starthour).val(_this.time_start_time.split(':')[0]).trigger('change');
					$(_this.$refs.startseconds).val(_this.time_start_time.split(':')[1]).trigger('change');
					$(_this.$refs.stophour).val(_this.time_end_time.split(':')[0]).trigger('change');
					$(_this.$refs.stopseconds).val(_this.time_end_time.split(':')[1]).trigger('change');
				}
				layer.confirm('', {
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: '使用时间选择',
					area: ['450px', ''], // 宽高
					content: $('.distb-time-popup'),
					cancel: function() {
						// 右上角关闭
						_this.dist_time = c_dist_time;
					}
				}, function() {
					if(_this.dist_time == '1') {
						_this.time_start_time = '00:00';
						_this.time_end_time = '00:00';
					} else {
						_this.createTimeString();
					}
					layer.closeAll();
				}, function() {
					_this.dist_time = c_dist_time;
				});
			},
			// 获取选择的时间
			createTimeString() {
				let _this = this;
				let starthour = $(_this.$refs.starthour).select2("val");
				let startseconds = $(_this.$refs.startseconds).select2("val");
				let stophour = $(_this.$refs.stophour).select2("val");
				let stopseconds = $(_this.$refs.stopseconds).select2("val");
				_this.time_start_time = starthour + ":" + startseconds;
				_this.time_end_time = stophour + ":" + stopseconds;
			},
			// 获取时间
			selectTime: function() {
				let _this = this;
				let seconds = [];
				for(let i = 0; i < 60; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					seconds[i] = item;
				};
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN"
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN"
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN"
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN"
				})
			},

			// 获取选中的星期日
			weekPop: function() {
				let _this = this;
				let c_week_checkboxModel = _this.week_checkboxModel;
				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['有效星期日', true],
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.week_popup),
					cancel: function() {
						// 右上角关闭
						if(_this.week != "") {
							_this.week_checkboxModel = c_week_checkboxModel;
							return;
						}
						_this.week_checkboxModel = [];
					}
				}, function() {
					let texts = [];
					_this.week_checkboxData.forEach(function(item) {
						_this.week_checkboxModel.forEach(function(item2) {
							if(item.id == item2){
								texts.push(item.name);
							}
						});
					});
					_this.week = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.week != "") {
						_this.week_checkboxModel = c_week_checkboxModel;
						return;
					}
					_this.week_checkboxModel = [];
				});
			},
			// 全选
			weekCheckedAll: function() {
				var _this = this;
				_this.week_allcheck = _this.c_week_allcheck;
				if(!_this.week_allcheck) { // 实现全选
					_this.week_checkboxModel = [];
					_this.week_checkboxData.forEach(function(item) {
						_this.week_checkboxModel.push(item.id);
					});
				} else { // 实现反选
					_this.week_checkboxModel = [];
				}
			},
			clear_input: function() {
				this.week = "";
				this.week_checkboxModel = [];
			},
			// 返回列表页
			backList: function() {
				this.showEdit = false;
				this.showDetail = false;
				this.showList = true;
			},
			// 新增/修改配送规则
			addSub: function(addModify) {
				let _this = this;
				let type;
				if(_this.distribt_type_name == '固定配送') {
					type = 1;
				} else if(_this.distribt_type_name == '手工配送') {
					type = 2;
				}
				// if(_this.box_allcheck.length != '0') {
				// 	_this.room_detailcheckboxdata.forEach(function(item) {
				// 		room_ids.push(item.id);
				// 	});
				// } else if(_this.room_checkboxModel.length != '0') {
				// 	room_ids = _this.room_checkboxModel;
				// }
				let datas;
				if(addModify == "1" || addModify == '4') {
					datas = {
						"header": Vue.request_header,
						"request": {
							"param": {
								"shop_id": $(_this.$refs.add_shop).val(), // 门店id
								"name": _this.add_rule, // 规则名称
								"listorder": _this.add_priority, // 优先级
								"rule_goods": _this.detail_list,
								"purchase_limit": _this.distribt_min, // 起购数
								"accumulate": _this.accumulate == false ? -1 : 1, // 累计配送
								"type": type,// 配送方式，1固定配送 2手工配送
								"present_goods": _this.distb_detail_list,
								"room_ids": _this.room_checkboxModel, // 适用包厢id，数组
								"use_all_room": _this.use_all_room,
								"use_every_day": _this.add_play_dateModel, // 是否适用每一天,-1：否，1：是
								"use_start_date": _this.add_startDate, // 使用开始日期,use_every_day=1时可传空
								"use_end_date": _this.add_endDate, // 使用结束日期,use_every_day=1时可传空
								"use_start_time": _this.time_start_time, // 使用开始时间
								"use_end_time": _this.time_end_time, // 使用结束时间
								"use_all_day": _this.use_all_day,
								"week_cycle": _this.week_checkboxModel, // 有效星期几,数组
								"present_max": _this.distb_all // 配送总数
                            }
                        },
                        "comment": ""
                    };
                } else {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "param": {
                                "id": _this.theDetail.id,
                                "shop_id": $(_this.$refs.add_shop).val(), // 门店id
								"name": _this.add_rule, // 规则名称
								"listorder": _this.add_priority, // 优先级
								"purchase_limit": _this.distribt_min, // 起购数
								"accumulate": _this.accumulate == false ? -1 : 1, // 累计配送
								"type": type,// 配送方式，1固定配送 2手工配送
								"present_goods": _this.distb_detail_list,
								"room_ids": _this.room_checkboxModel, // 适用包厢id，数组
								"use_all_room": _this.use_all_room,
								"use_every_day": _this.add_play_dateModel, // 是否适用每一天,-1：否，1：是
								"use_start_date": _this.add_startDate, // 使用开始日期,use_every_day=1时可传空
								"use_end_date": _this.add_endDate, // 使用结束日期,use_every_day=1时可传空
								"use_start_time": _this.time_start_time, // 使用开始时间
								"use_end_time": _this.time_end_time, // 使用结束时间
								"use_all_day": _this.use_all_day,
								"week_cycle": _this.week_checkboxModel, // 有效星期几,数组
								"present_max": _this.distb_all // 配送总数
                            }
                        },
                        "comment": ""
                    };
                }
                datas = JSON.stringify(datas);
                $.ajax({
                    type: "POST",
                    dataType: "json",
                    url: Vue.ctUrl + "PresentGoodsRule/editRule",
                    async: true,
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas,
                    success: function(data) {
                        if(data['response']['result_code'] == "true") {
                            layer.msg(data["response"]["error_msg"]);
                            $(_this.$refs.distribt_list).bootstrapTable('refresh');

                            _this.showEdit = false;
                            _this.showList = true;
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data["response"]["error_msg"]);
                        }
                    },
                    error: function(err) {

                    }
                });
			},

			// 详情
			getDetail: function(id) {
				let _this = this;
				var layIndex = layer.load(0, {
					shade: [0.1, '#ececec']
				});
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PresentGoodsRule/getDetail",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
                    data: datas2,
					success: function(data) {
						_this.theDetail = data.response.result;

						$(_this.$refs.add_shop).val(_this.theDetail.shop_id).trigger('change');
						$(_this.$refs.add_shop).prop('disabled', true);
						_this.add_rule = _this.theDetail.name;
						_this.add_priority = _this.theDetail.listorder;
						_this.detail_list = _this.theDetail.rule_goods;
						_this.right_goods = _this.theDetail.rule_goods[0].goods_name;
						$(_this.$refs.right_goods).prop('disabled', true);
						_this.distribt_min = _this.theDetail.purchase_limit;
						_this.accumulate = _this.theDetail.accumulate == 1 ? true : false,
						_this.distribt_type_id = _this.theDetail.type;
						_this.distribt_type_name = _this.theDetail.type_name;
						_this.distb_detail_list = _this.theDetail.present_goods;
						$(_this.$refs.distb_table).bootstrapTable('destroy');
						_this.initDistbGoods();
						_this.distribt_gooods = [];
						$.each(_this.distb_detail_list, function(k, v) {
							_this.distribt_gooods.push(v.goods_name);
						});
						// 包厢
						_this.getAllRoomByArea($(_this.$refs.add_shop).val(), 1);
						if(_this.theDetail.use_all_room == '1') {
							_this.distribt_box_txt = '全部包厢';
							// _this.box_allcheck = ['0']
							_this.room_detailcheckboxdata.forEach(function(item) {
		                        _this.room_checkboxModel.push(item.id);
		                    });
						} else {
							_this.distribt_box_txt = _this.theDetail.room_info;
							_this.room_checkboxModel = _this.theDetail.room_ids;
						}
						_this.use_all_room = _this.theDetail.use_all_room;

						setTimeout(function() {
							_this.selDate();
							if ( _this.theDetail.use_every_day == "1" ) {
								// $(_this.$refs.add_play_date).val("每天");
								_this.add_play_date = '每天';
								_this.add_play_dateModel = '1';
							} else {
								$(_this.$refs.add_play_date).data('daterangepicker').setStartDate(_this.theDetail.use_start_date);
								$(_this.$refs.add_play_date).data('daterangepicker').setEndDate(_this.theDetail.use_end_date);

								_this.add_play_date = _this.theDetail.use_start_date + ' - ' + _this.theDetail.use_end_date;
								_this.add_startDate = _this.theDetail.use_start_date;
								_this.add_endDate = _this.theDetail.use_end_date;
								_this.add_play_dateModel = '-1';
							}
						}, 500);

						_this.week = _this.theDetail.week_cycle_info;
						_this.week_checkboxModel = _this.theDetail.week_cycle;

						_this.time_start_time = _this.theDetail.use_start_time;
						_this.time_end_time = _this.theDetail.use_end_time;
						if(_this.theDetail.use_all_day == '1') {
							_this.dist_time = '1';
							_this.use_all_day = '1';
						} else {
							_this.use_all_day = '-1';
						}

						_this.distb_all = _this.theDetail.present_max;

						if(_this.addModify == 2 || _this.addModify == 4) {
							$(_this.$refs.add_priority).prop('disabled', false);
							$(_this.$refs.add_rule).prop('disabled', false);
							$(_this.$refs.distribt_min).prop('disabled', false);
							$(_this.$refs.add_distribt_type).prop('disabled', false);
							$(_this.$refs.distribt_gooods).prop('disabled', false);
							$(_this.$refs.distribt_box_txt).prop('disabled', false);
							$(_this.$refs.add_play_date).prop('disabled', false);
							$(_this.$refs.add_play_time).prop('disabled', false);
							$(_this.$refs.week).prop('disabled', false);
							if (_this.addModify == 4) {
								$(_this.$refs.right_goods).prop('disabled', false);
								$(_this.$refs.right_goods_table).bootstrapTable("destroy");
								_this.initRightGoods();
							}
						} else {
							$(_this.$refs.add_priority).prop('disabled', true);
							$(_this.$refs.add_rule).prop('disabled', true);
							$(_this.$refs.distribt_min).prop('disabled', true);
							$(_this.$refs.add_distribt_type).prop('disabled', true);
							$(_this.$refs.distribt_gooods).prop('disabled', true);
							$(_this.$refs.distribt_box_txt).prop('disabled', true);
							$(_this.$refs.add_play_date).prop('disabled', true);
							$(_this.$refs.add_play_time).prop('disabled', true);
							$(_this.$refs.week).prop('disabled', true);
							$('.distribt-edit input').addClass('white-bg');
						}

						layer.close(layIndex);
					},
					error: function(err) {
						layer.msg("出错啦");
						layer.close(layIndex);
					}
				});
			},

		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.commodity-distribt {
		.pdmg {
			margin: 0px 0 0 -15.5px;
		}
		.text-orange {
			color: #009af0;
			cursor: pointer;
		}
	
		table {
			table-layout: fixed;
		}
		table .room-info-td {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}
	.distribt-edit {
		.white-bg {
			background-color: #FFF !important;
			cursor: default !important;
		}
		.distribt-usedate-wrap {
			position: relative;
		}
		.flex-row {
			display: flex;
			flex-direction: row;
			align-items: center;
			.el-checkbox {
				margin-left: 10px;
			}
		}
	}

	/* 配送方式弹窗 */
	.type_popup {
		display: none;
		.chooseType-content {
			width: 100%;
			padding-left: 80px;
			margin: 30px auto;
			li {
				width: 100%;
				color: #5e5e5e;
				font-size: 14px;
				margin-bottom: 10px;
				.choosetype-txt {
					width: 250px;
					display: inline-block;
					p {
						line-height: 24px;
						color: #606060;
						font-size: 14px;
						margin: 0;
						&.orange-text {
							color: #009af0;
							font-size: 12px;
							line-height: 16px;
							height: auto!important;
						}
					}
				}
				input {
					float: left;
					margin-right: 10px;
				}
			}
		}
		.chooseType-btn {
			overflow: hidden;
			width: 350px;
			margin: 0 auto;
			button {
				float: left;
				margin-top: 30px;
			}
		}
	}
	/* 时间选择弹窗 */
	.distb-time-popup {
		display: none;
		.chooseTime_popup-wrap {
			padding: 20px 60px;
			.chooseTime_popup_title {
				overflow: hidden;
				font-size: 16px;
				color: #333;
				margin: 10px;
				div {
					float: right;
					label {
						font-weight: normal;
					}
				}
			}
			.select2 {
				width: 150px!important;
			}
			.select2-selection--single {
				height: 46px;
				line-height: 46px;
				border-radius: 0!important;
				outline: none;
				border: 1px solid #d5d5d5!important;
				.select2-selection__rendered {
					line-height: 46px;
					color: #9d9d9d;
					font-size: 20px;
				}
				.select2-selection__arrow {
					height: 46px;
					line-height: 46px;
				}
			}
			.colon {
				width: 18px;
				text-align: center;
				line-height: 45px;
				font-size: 20px;
				color: #9d9d9d;
				margin-bottom: 0px;
			}
		}
	}
	.page-right-goods {
		.page-right-goods-txt {
			margin: 20px 0 0;
			text-align: center;
			font-size: 14px;
		}
		.good-img {
			display: block;
			width: 50px;
			margin: 0 auto;
		}
		.delete {
			color: #009af0;
			cursor: pointer;
		}
	}
	.add-goods, .add-disbt-goods {
		width: 100%;
		height: 100%;
		padding: 20px 30px;
		display: none;
		#good-name {
			border: 1px solid #FF6700;
		}
		.btns {
			margin-top: 10px;
			position: absolute;
			bottom: 30px;
			#pop-save {
				margin-left: 140px;
			}
		}
		.table-responsive {
			width: 100%;
			padding: 0;
		}
	}
	
	.page-distb {
		h3 {
			margin: 30px 0;
			text-align: center;
		}
		img {
			display: block;
			width: 50px;
			margin: 0 auto;
		}
		.delete {
			color: #009af0;
			cursor: pointer;
		}
	}
	.distb-room-page {
		.distb-room-type {
			margin: 30px 0;
			li {
				float: left;
				width: 130px;
				height: 40px;
				border: 1px solid #CCC;
				margin: 0 30px 0 0;
				line-height: 40px;
				color: #CCC;
				text-align: center;
				cursor: pointer;
			}
			.distb-room-sel {
				border: 1px solid #009af0;
				color: #FFF;
				background: #009af0;
			}
		}
		.box_area {
			ul {
				padding: 10px 30px 20px 54px;
			}
		}
	}

	/* 有效星期日 */
	#week_popup {
		display: none;
		.week_popup-wrap {
			padding: 20px 0 30px 180px;
			li {
				height: 30px;
				line-height: 30px;
				margin-bottom: 10px;
				label {
					margin: 0;
					height: 30px;
					line-height: 30px;
					font-weight: normal;
					font-size: 14px;
					color: #333;
				}
				input[type="checkbox"] {
					float: left;
					margin-right: 20px;
					margin-top: 8px;
				}
			}
		}
	}
	.ct-alert {
		cursor: pointer;
	}
</style>